import { render, staticRenderFns } from "./StudyManager.vue?vue&type=template&id=251a00e4&"
import script from "./StudyManager.vue?vue&type=script&lang=js&"
export * from "./StudyManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports